import React from "react";
import "./Lifting_Buildings.css";
import { Link } from "react-router-dom";
import ContactSection2 from "./ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function BuildingRehabilitation() {
  return (
    <div className="Lifting_Buildings-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="Lifting_Buildings-hero">
        <div className="Lifting_Buildings-overlay">
          <h1>הובלת קרוואנים</h1>
        </div>

        <div></div>
      </div>


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הובלת קרוואנים עם נצר הובלות ומנופים
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/7.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי הובלת הקרוואנים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הובלת קרוואנים דורשת תכנון מקצועי, ציוד מתאים
            וניסיון בעבודה עם מבנים ניידים. נצר הובלות ומנופים
            מספקת פתרונות הובלה לקרוואנים בהתאם לגודל הקרוואן,
            תנאי הדרך ומקום היעד.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/40.jpeg"
                alt="הובלת קרוואנים"
              />
            </div>

            <div className="text-box">

              <p>
                הובלת קרוואן ממקום למקום דורשת בדיקה מוקדמת
                של תנאי הדרך והתאמת אמצעי ההובלה לקרוואן.
                לפני תחילת העבודה חשוב לבדוק את מידות הקרוואן,
                המשקל, נקודת המוצא, נקודת היעד ואפשרויות הגישה.
              </p>

              <p>
                נצר הובלות ומנופים מספקת שירותי הובלת קרוואנים
                ומסייעת בתכנון מסלול ההובלה בהתאם לתנאים
                הקיימים בשטח ולמאפייני הקרוואן.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלת קרוואנים – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              לפני הובלת קרוואן חשוב לבדוק את מסלול הנסיעה
              ולוודא שהדרך מתאימה למידות הקרוואן. יש להתחשב
              ברוחב הכביש, בגובה המעברים, בפניות ובמכשולים
              שעלולים להופיע בדרך.
            </p>

            <p>
              תכנון מוקדם מאפשר לבחור את אמצעי ההובלה המתאים
              ולתכנן את העבודה בצורה מסודרת ככל האפשר.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת קרוואנים באמצעות ציוד מתאים
            </h2>

            <p>
              בהתאם למידות הקרוואן ולתנאי השטח, יש להתאים את
              אמצעי ההובלה והציוד הדרושים לביצוע העבודה.
              התאמה נכונה מסייעת לבצע את ההובלה בצורה מסודרת.
            </p>

            <p>
              במקרים שבהם נדרשת גם הרמה של הקרוואן, יש לבחון
              מראש את תנאי הגישה ואת האפשרות להציב את ציוד
              ההרמה במקום המתאים.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת קרוואנים למרחקים שונים
            </h2>

            <p>
              הובלת קרוואנים יכולה להתבצע בתוך אותו יישוב,
              בין יישובים שונים או בין אזורים שונים בארץ.
              לכל הובלה יש להתאים את מסלול הנסיעה בהתאם
              למרחק ולתנאי הדרך.
            </p>

            <p>
              נצר הובלות ומנופים מספקת פתרונות הובלה לקרוואנים
              בהתאם לצורכי הלקוח ולמאפייני הפרויקט.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הובלת קרוואנים במקומות עם גישה מורכבת
            </h2>

            <p>
              לעיתים הקרוואן ממוקם בחצר, באתר בנייה, ברחוב צר
              או באזור צפוף שבו הגישה למשאית מורכבת. במקרים
              כאלה יש צורך לבצע בדיקה מקדימה ולתכנן את אופן
              ההובלה.
            </p>

            <p>
              בדיקה מוקדמת של המקום יכולה לסייע לזהות
              מכשולים ומגבלות ולבחור את הפתרון המתאים
              לביצוע העבודה.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הצבת הקרוואן במקום החדש
            </h2>

            <p>
              לאחר הגעת הקרוואן אל היעד יש לבצע את שלב
              ההצבה בצורה מסודרת ובהתאם למיקום שנקבע מראש.
              כאשר נדרשת הצבה מדויקת, חשוב לתכנן את נקודת
              המיקום ואת אפשרויות הגישה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההובלה
              וההרמה לתנאי השטח ולמיקום שבו נדרש להציב
              את הקרוואן.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להובלת קרוואנים?
            </h2>

            <p>
              הובלת קרוואן אינה זהה להובלה רגילה. מדובר
              במבנה בעל מידות ומשקל שדורשים תכנון מתאים
              של המסלול ושל אמצעי ההובלה.
            </p>

            <p>
              חברה מקצועית יכולה לבחון את תנאי העבודה מראש,
              להתאים את אמצעי ההובלה ולתכנן את שלבי העבודה
              בהתאם לקרוואן ולמקום.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הובלת קרוואנים
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלה,
              הרמה ומנוף למגוון רחב של עבודות, כולל הובלת
              קרוואנים ומבנים ניידים.
            </p>

            <p>
              צריכים להוביל קרוואן? צרו איתנו קשר, ספרו לנו
              על העבודה ונבחן עבורכם את פתרון ההובלה וההרמה
              המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Relocation_of_buildings"
              className="link-right"
            >
              העברת מבנים
            </Link>

            <Link
              to="/Transportation_of_protective_equipment_and_mobile_safe_room"
              className="link-left"
            >
              הובלת מיגונית וממ"ד נייד
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}